import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNotificationH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.003 6.75C48.581 6.75 58.67 17.22 58.67 30v11.426l3.867 7.049c1.92 3.498-.612 7.774-4.602 7.775H14.072c-3.991 0-6.522-4.277-4.603-7.775l3.867-7.05V30c0-12.78 10.09-23.25 22.667-23.25M47.35 59.25A12.92 12.92 0 0 1 36 65.985a12.92 12.92 0 0 1-11.35-6.735z"
  }));
}
var IcNotificationH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNotificationH72));

export { IcNotificationH72 as I };
